module.exports = __webpack_public_path__ + "static/media/assa.1ea8fa7e.png";